import { Outlet, useLocation, Navigate } from "react-router-dom";
import { useAuthStatus } from "../../lib/stores/auth-store";
import Navbar from "./Navbar";
import Header from "./Header";

const Layout = () => {
  const isLoggedIn = useAuthStatus((state) => state.isLoggedIn);

  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div>
      <header>
        <Header />
      </header>

      <div>
        <Navbar />
        <main className="md:ml-56 pt-14 md:pt-20">
          <div className="p-3 md:p-6">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
